export default __webpack_public_path__ + "static/char-v-50-ja-f005a800abec6ff00c3c9e1bfc719d0e.mp4";